package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Tajikistan Flag (32x24dp)
 *
 * - ISO Alpha-2: TJ
 * - ISO Alpha-3: TJK
 * - ISO Numeric: 762
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Tajikistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Tajikistan:TJ:TJK:762:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(8f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 16f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.02f, 8.63f)
                lineTo(15.429f, 9.048f)
                lineTo(15.637f, 8.348f)
                lineTo(15.064f, 7.906f)
                lineTo(15.784f, 7.891f)
                lineTo(16.02f, 7.2f)
                lineTo(16.257f, 7.891f)
                lineTo(16.977f, 7.906f)
                lineTo(16.403f, 8.348f)
                lineTo(16.611f, 9.048f)
                lineTo(16.02f, 8.63f)
                close()
                moveTo(13.523f, 9.243f)
                lineTo(12.932f, 9.66f)
                lineTo(13.14f, 8.96f)
                lineTo(12.566f, 8.518f)
                lineTo(13.287f, 8.504f)
                lineTo(13.523f, 7.813f)
                lineTo(13.759f, 8.504f)
                lineTo(14.48f, 8.518f)
                lineTo(13.906f, 8.96f)
                lineTo(14.114f, 9.66f)
                lineTo(13.523f, 9.243f)
                close()
                moveTo(10.99f, 11.499f)
                lineTo(11.581f, 11.081f)
                lineTo(12.172f, 11.499f)
                lineTo(11.964f, 10.799f)
                lineTo(12.537f, 10.357f)
                lineTo(11.817f, 10.342f)
                lineTo(11.581f, 9.651f)
                lineTo(11.344f, 10.342f)
                lineTo(10.624f, 10.357f)
                lineTo(11.198f, 10.799f)
                lineTo(10.99f, 11.499f)
                close()
                moveTo(10.957f, 13.464f)
                lineTo(10.365f, 13.882f)
                lineTo(10.574f, 13.182f)
                lineTo(10f, 12.74f)
                lineTo(10.72f, 12.725f)
                lineTo(10.957f, 12.034f)
                lineTo(11.193f, 12.725f)
                lineTo(11.913f, 12.74f)
                lineTo(11.339f, 13.182f)
                lineTo(11.548f, 13.882f)
                lineTo(10.957f, 13.464f)
                close()
                moveTo(20.423f, 13.882f)
                lineTo(21.014f, 13.464f)
                lineTo(21.605f, 13.882f)
                lineTo(21.397f, 13.182f)
                lineTo(21.971f, 12.74f)
                lineTo(21.251f, 12.725f)
                lineTo(21.014f, 12.034f)
                lineTo(20.778f, 12.725f)
                lineTo(20.058f, 12.74f)
                lineTo(20.632f, 13.182f)
                lineTo(20.423f, 13.882f)
                close()
                moveTo(20.251f, 11.081f)
                lineTo(19.66f, 11.499f)
                lineTo(19.869f, 10.799f)
                lineTo(19.295f, 10.357f)
                lineTo(20.015f, 10.342f)
                lineTo(20.251f, 9.651f)
                lineTo(20.488f, 10.342f)
                lineTo(21.208f, 10.357f)
                lineTo(20.634f, 10.799f)
                lineTo(20.843f, 11.499f)
                lineTo(20.251f, 11.081f)
                close()
                moveTo(17.747f, 9.66f)
                lineTo(18.338f, 9.243f)
                lineTo(18.929f, 9.66f)
                lineTo(18.721f, 8.96f)
                lineTo(19.295f, 8.518f)
                lineTo(18.575f, 8.504f)
                lineTo(18.338f, 7.813f)
                lineTo(18.102f, 8.504f)
                lineTo(17.382f, 8.518f)
                lineTo(17.956f, 8.96f)
                lineTo(17.747f, 9.66f)
                close()
                moveTo(12.667f, 16.755f)
                lineTo(12.483f, 16.098f)
                curveTo(13.503f, 15.822f, 14.674f, 15.685f, 15.997f, 15.685f)
                curveTo(17.319f, 15.685f, 18.49f, 15.822f, 19.51f, 16.098f)
                lineTo(19.326f, 16.755f)
                curveTo(18.369f, 16.496f, 17.26f, 16.366f, 15.997f, 16.366f)
                curveTo(14.733f, 16.366f, 13.623f, 16.496f, 12.667f, 16.755f)
                close()
                moveTo(13.931f, 15.702f)
                curveTo(13.524f, 15.771f, 13.191f, 15.378f, 13.191f, 15.378f)
                lineTo(13.594f, 15.211f)
                curveTo(13.582f, 14.931f, 13.751f, 14.757f, 13.751f, 14.757f)
                curveTo(13.887f, 14.82f, 14.073f, 15.164f, 14.073f, 15.164f)
                horizontalLineTo(14.439f)
                curveTo(14.439f, 15.164f, 14.338f, 15.633f, 13.931f, 15.702f)
                close()
                moveTo(18.74f, 15.446f)
                curveTo(18.74f, 15.446f, 18.407f, 15.839f, 18f, 15.77f)
                curveTo(17.593f, 15.701f, 17.491f, 15.232f, 17.491f, 15.232f)
                horizontalLineTo(17.857f)
                curveTo(17.857f, 15.232f, 18.044f, 14.888f, 18.18f, 14.825f)
                curveTo(18.18f, 14.825f, 18.349f, 14.999f, 18.336f, 15.279f)
                lineTo(18.74f, 15.446f)
                close()
                moveTo(15.945f, 15.577f)
                curveTo(15.533f, 15.589f, 15.258f, 15.153f, 15.258f, 15.153f)
                lineTo(15.681f, 15.044f)
                curveTo(15.707f, 14.765f, 15.899f, 14.617f, 15.899f, 14.617f)
                curveTo(16.025f, 14.698f, 16.162f, 15.064f, 16.162f, 15.064f)
                lineTo(16.524f, 15.116f)
                curveTo(16.524f, 15.116f, 16.358f, 15.566f, 15.945f, 15.577f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.958f, 13.699f)
                curveTo(15.958f, 13.699f, 15.49f, 14.772f, 14.751f, 14.855f)
                curveTo(14.012f, 14.938f, 13.637f, 14.245f, 13.637f, 14.245f)
                curveTo(13.637f, 14.245f, 13.589f, 14.966f, 12.712f, 15.244f)
                curveTo(11.834f, 15.522f, 11.372f, 14.411f, 11.372f, 14.411f)
                curveTo(11.372f, 14.411f, 11.829f, 14.819f, 12.537f, 14.642f)
                curveTo(13.246f, 14.464f, 13.525f, 13.806f, 13.525f, 13.806f)
                curveTo(13.525f, 13.806f, 14.05f, 14.491f, 14.751f, 14.149f)
                curveTo(15.452f, 13.806f, 15.84f, 13.387f, 15.84f, 12.985f)
                verticalLineTo(11.784f)
                curveTo(15.84f, 11.784f, 15.659f, 11.472f, 15.345f, 11.472f)
                curveTo(15.031f, 11.472f, 14.944f, 11.693f, 14.944f, 11.693f)
                curveTo(14.944f, 11.693f, 14.821f, 10.443f, 15.95f, 10.365f)
                lineTo(15.95f, 10.362f)
                curveTo(15.961f, 10.363f, 15.971f, 10.363f, 15.982f, 10.363f)
                curveTo(15.992f, 10.363f, 16.002f, 10.363f, 16.013f, 10.362f)
                lineTo(16.013f, 10.365f)
                curveTo(17.142f, 10.443f, 17.019f, 11.693f, 17.019f, 11.693f)
                curveTo(17.019f, 11.693f, 16.932f, 11.472f, 16.618f, 11.472f)
                curveTo(16.304f, 11.472f, 16.123f, 11.784f, 16.123f, 11.784f)
                verticalLineTo(12.985f)
                curveTo(16.123f, 13.387f, 16.511f, 13.806f, 17.212f, 14.149f)
                curveTo(17.914f, 14.491f, 18.438f, 13.806f, 18.438f, 13.806f)
                curveTo(18.438f, 13.806f, 18.717f, 14.464f, 19.426f, 14.642f)
                curveTo(20.134f, 14.819f, 20.591f, 14.411f, 20.591f, 14.411f)
                curveTo(20.591f, 14.411f, 20.129f, 15.522f, 19.252f, 15.244f)
                curveTo(18.374f, 14.966f, 18.326f, 14.245f, 18.326f, 14.245f)
                curveTo(18.326f, 14.245f, 17.951f, 14.938f, 17.212f, 14.855f)
                curveTo(16.474f, 14.772f, 16.005f, 13.699f, 16.005f, 13.699f)
                lineTo(15.982f, 12.282f)
                lineTo(15.958f, 13.699f)
                close()
                moveTo(15.948f, 10.702f)
                curveTo(15.427f, 10.702f, 15.322f, 11.143f, 15.322f, 11.143f)
                curveTo(15.78f, 11.143f, 15.948f, 11.343f, 15.948f, 11.343f)
                curveTo(15.948f, 11.343f, 16.288f, 11.143f, 16.629f, 11.143f)
                curveTo(16.629f, 11.143f, 16.469f, 10.702f, 15.948f, 10.702f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun TajikistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Tajikistan,
            contentDescription = "Tajikistan Flag"
        )
    }
}
